import EcoSpace from 'eco-design/base/eco-space';
import { useState } from 'react';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { OPEN_QUOTE_WIN_KEY } from '../../../FreeQuote';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/i18n';

export default function D({ tags, handleClick }: any) {
    const { locale = 'us' } = getLocal();
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('powerbackup');
    const [active, setActive] = useState(tags[0]?.link);

    return (
        <div id="power-backup-D" className={`power-backup-D ef-layer ${css['power-backup-D']}`}>
            <EcoSpace />
            <div className="text-box">
                <p className="title">{t('secD_title')}</p>
            </div>
            <div className="tags">
                {tags?.map((tag: any, k: number) => (
                    <a
                        className={`tag${active === tag?.link ? ' active' : ''}`}
                        href={tag?.link}
                        key={k}
                        onClick={() => {
                            handleClick?.(tag);
                            setActive(tag?.link);
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'tab_click',
                                button_name: tag?.text,
                                list_name: t('secD_title'),
                            });
                        }}
                    >
                        {tag?.text}
                    </a>
                ))}
            </div>
            {locale === 'us' && (
                <div
                    className="GAQ-btn GtmModuleData-btn-common"
                    data-btn-id="GAQ_Btn_Preparing"
                    onClick={() => {
                        EcoDesignEventsBus.emit(OPEN_QUOTE_WIN_KEY, true);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'floating_button',
                            button_name: `GAQ_Btn_Preparing`,

                            __btn_id1: `power-backup-D .GAQ-btn`,
                            __btn_id2: `GAQ_Btn_Preparing`,
                            __btn_type: 'common',
                        });
                    }}
                >
                    <img className="left-icon" src="https://websiteoss.ecoflow.com/upload/image/1764817232869/feedback.png" />
                    <span>{t('secA_btn2')}</span>
                    <img className="right-icon" src="https://websiteoss.ecoflow.com/upload/image/1764817233229/icon-arrow.png" />
                </div>
            )}
        </div>
    );
}
